export default __webpack_public_path__ + "static/media/Pastry-Almond-Tart.d975d1eb.jpg";